import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import useRoutes from '../routes/useRoutes';

import StartPageView from '../views/StartPageView';
import MenuView from '../views/MenuView';
import PPSIView from '../views/PPSIView';
import PPIView from '../views/PPIView';
import PrepAndProdCheatSheetView from '../views/PrepAndProdCheatSheetView';
import SettingsView from '../views/SettingsView';
import MainLayout from './Layout/MainLayout';

const AppRoutes = () => {
  const routes = useRoutes();
  const location = useLocation();

  return (
    <Routes>
      {/* Standalone routes */}
      <Route path="/" element={<StartPageView />} />
      <Route path={routes.startPageRoute()} element={<StartPageView />} />
      <Route path={routes.redirectRoute()} element={<Navigate to={routes.menuRoute()} replace />} />

      {/* Routes under MainLayout */}
      <Route element={<MainLayout />}>
        <Route path={routes.menuRoute()} element={<MenuView />} />
        <Route path={routes.ppsiRoute()} element={<PPSIView />} />
        <Route path={routes.ppiRoute()} element={<PPIView />} />
        <Route path={routes.prepAndProdCheatSheetRoute()} element={<PrepAndProdCheatSheetView />} />
        <Route path={routes.settingsPageRoute()} element={<SettingsView />} />
        <Route path="*" element={<Navigate to={`/error${location.search}`} replace />} />
      </Route>
    </Routes>
  );
};

export default AppRoutes;
